import ReactFileReader from 'react-file-reader';
import URLEndPointBE from './URLEndPointBE'
import DisplayFoto from './DisplayFoto';

function HandleFoto(props: any) {
    console.log(props);
    let _foto;
    switch(props.foto.state) {
        case 'WAITING':
            _foto = <div className={'divFoto'}>
                        <div className={'fotoFrame'}></div>
                        <div>&nbsp;</div>
                        <ReactFileReader fileTypes={[".jpg", ".png", ".jpeg"]} base64={true} multipleFiles={false} handleFiles={(e: any) => props.handle_pridat_foto(props.i, e) }>
                            <span className='katBtnStyle ptHover'>PŘIDAT FOTO</span>
                        </ReactFileReader>
                    </div>;
            break;
        case 'VIEWING':
            _foto = <div className={'divFoto'}>
                        <div className={'fotoFrame'}>
                            <img src={URLEndPointBE+`/foto/`+props.foto.id}/>
                        </div>
                        <div>&nbsp;</div>
                        <span className='katBtnStyle ptHover' onClick={(e: any)=>props.handle_smazat_foto(props.i)}>SMAZAT FOTO</span>
                    </div>;  
            break;
        case 'INSERT':
            _foto = <div className={'divFoto'}>
                        <div className={'fotoFrame'}>
                            <img src={props.foto.base64}/>
                        </div>
                        <div>&nbsp;</div>
                        <span className='katBtnStyle ptHover' onClick={(e: any)=>props.handle_smazat_foto(props.i)}>SMAZAT FOTO</span>
                    </div>;  
            break;
        case 'DELETE':
            _foto = <div className={'divFoto'}>
                        <div className={'fotoFrame'}></div>
                        <div>&nbsp;</div>
                        <ReactFileReader fileTypes={[".jpg", ".png", ".jpeg"]} base64={true} multipleFiles={false} handleFiles={(e: any) => props.handle_pridat_foto(props.i, e) }>
                            <span className='katBtnStyle ptHover'>PŘIDAT FOTO</span>
                        </ReactFileReader>
                    </div>;
            break;  
        default:
            _foto = <span>default</span>;
            break;          
    }

    return ( <span>
        {_foto}
        </span>
        )
}
export default HandleFoto